import React from "react";
import { Alert } from "@mui/material";

export default function ReviewValidationBanner({ issues = [] }) {
  if (!issues.length) return null;
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <strong>Please fix these before continuing:</strong>
      <ul style={{ margin: "6px 0 0 18px" }}>
        {issues.map((msg, i) => (
          <li key={i}>{msg}</li>
        ))}
      </ul>
    </Alert>
  );
}
